<script>
import { isImminent, isEnded } from '../../utils/Time';

export default {
  name: 'RelativeTime',
  props: {
    // This prop supports Numbers and Strings! Not sure which is correct
    // eslint-disable-next-line vue/require-prop-types
    targetTime: {
      required: true,
    },
  },
  data() {
    return {
      currentTime: Date.now(),
    };
  },
  computed: {
    imminent() {
      return isImminent(this.targetTime);
    },
    isEnded() {
      return isEnded(this.targetTime);
    },
  },
  mounted() {
    window.setInterval(() => {
      this.currentTime = Date.now();
    }, 1000);
  },
};
</script>

<template>
  <div class="relative-time">
    <abbr :data-ticking="currentTime" :class="[{ 'imminent': imminent }, { 'is-ended': isEnded }, 'relative-time__inner']">
      <span>{{ targetTime | countdown }}</span>
    </abbr>
  </div>
</template>
